import React from "react";

import AutoStatusIcon from "@uui/Stars02";

import Box from "@mui/material/Box";
import styled from "@mui/material/styles/styled";

import ChangeStatusMenu from "@app/analytics/components/ChangeStatusMenu";
import {
  AUTO_ACTION_ITEM_STATUSES,
  ACTION_ITEM_STATUS_CONFIG,
} from "@app/analytics/constants/statusChips";
import { ActionButton } from "@app/analytics/Home/components/styles";
import type {
  ActionItemChipStatus,
  ActionItemClipStatus,
} from "@app/common/types";
import useAnchorElement from "@app/utils/hooks/useAnchorElement";

const StatusIndicator = styled(Box)({
  height: "4px",
  width: "4px",
  borderRadius: "50%",
});

const getStatusIndicator = (status: ActionItemChipStatus) => {
  switch (status) {
    case "read_active":
    case "user_active":
      return <StatusIndicator sx={{ bgcolor: "shades.secondary.500" }} />;
    case "read_inactive":
    case "user_inactive":
      return <StatusIndicator sx={{ bgcolor: "shades.neutral.300" }} />;
    default:
      return;
  }
};

const ActionItemStatusButton = ({
  disabled = false,
  status,
  onChangeStatus,
}: {
  disabled?: boolean;
  status: ActionItemChipStatus;
  onChangeStatus: (status: ActionItemClipStatus) => void;
}) => {
  const { anchorElement, open, onClick, onClose } = useAnchorElement();

  const isAutoStatus = AUTO_ACTION_ITEM_STATUSES.includes(status);

  const handleChangeStatus = (updatedStatus: ActionItemClipStatus) => {
    onChangeStatus(updatedStatus);
    onClose();
  };

  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    event.stopPropagation();
    onClick(event);
  };

  return (
    <>
      <ActionButton
        disabled={disabled}
        onClick={handleClick}
        startIcon={getStatusIndicator(status)}
        endIcon={
          isAutoStatus && (
            <AutoStatusIcon
              sx={{ width: "13px", color: "shades.neutral.300" }}
            />
          )
        }
      >
        {ACTION_ITEM_STATUS_CONFIG[status].label}
      </ActionButton>
      <ChangeStatusMenu
        onClose={onClose}
        open={open}
        anchorEl={anchorElement}
        onChangeStatus={handleChangeStatus}
        status={status}
      />
    </>
  );
};

export default ActionItemStatusButton;
